import type { HttpApiServerType } from '@/services/http-api/httpApi';
import PhpIcon from '@/ui-kit/components/SchemaGenerator/languageIcon/php.svg?react';
import ShellIcon from '@/ui-kit/components/SchemaGenerator/languageIcon/shell.svg?react';
import { Tabs } from 'aui';
import {
  FoxIconAC2,
  FoxIconC,
  FoxIconDart1,
  FoxIconDotsVertical,
  FoxIconGo1,
  FoxIconHttp,
  FoxIconJava,
  FoxIconJavascript1,
  FoxIconObjectiveC1,
  FoxIconOcaml,
  FoxIconPython,
  FoxIconR,
  FoxIconRuby1,
  FoxIconSwift,
} from 'aui-biz-icons';
import clsx from 'clsx';
import React from 'react';
import styles from './RequestSampleCodeClassicsLanguages.module.css';

export type RequestSampleCodeClassicsLanguagesProps = {
  languages: HttpApiServerType['codeSampleLanguages'];
  value: string | undefined;
  onChange: (value: string | undefined) => void;
  className?: string;
};

export function RequestSampleCodeClassicsLanguages(props: RequestSampleCodeClassicsLanguagesProps) {
  const { languages, value, onChange, className } = props;

  const languageIconMap = React.useMemo(() => {
    const result: Record<string, React.ReactNode> = {
      shell: (
        <ShellIcon
          style={{
            width: 16,
            height: 16,
          }}
        />
      ),
      javascript: <FoxIconJavascript1 size={16} />,
      java: <FoxIconJava size={16} />,
      swift: <FoxIconSwift size={16} />,
      go: <FoxIconGo1 size={16} />,
      php: (
        <PhpIcon
          style={{
            width: 16,
            height: 16,
          }}
        />
      ),
      python: <FoxIconPython size={16} />,
      http: <FoxIconHttp size={16} />,
      c: <FoxIconC size={16} />,
      csharp: <FoxIconAC2 size={16} />,
      'objective-c': <FoxIconObjectiveC1 size={16} />,
      ruby: <FoxIconRuby1 size={16} />,
      ocaml: <FoxIconOcaml size={16} />,
      dart: <FoxIconDart1 size={16} />,
      r: <FoxIconR size={16} />,
    };
    return result;
  }, []);

  return (
    <Tabs
      activeKey={value ?? ''}
      onTabClick={(v) => {
        if (v === value) {
          onChange(undefined);
          return;
        }

        onChange(String(v));
      }}
      items={languages.map((language) => ({
        key: language.key,
        label: (
          <div className="flex flex-col items-center">
            {languageIconMap[language.key]}
            <div className="mt-2">{language.label}</div>
          </div>
        ),
      }))}
      className={clsx(styles.tabs, className)}
      moreIcon={<FoxIconDotsVertical />}
      type="button"
    />
  );
}
